export class FilterMixitupOptions {
	classNames: {
        block?:string;
        elementContainer?:string;
        elementFilter?:string;
        elementSort?:string;
        elementMultimix?:string;
        elementToggle?:string;
        modifierActive?: string;
        modifierDisabled?: string;
        modifierFailed?: string;
        delineatorElement?: string;
        delineatorModifier?: string;
    };
	load: {
        filter?: string;
        sort?:string;
    };
    selectors: {
        filter?: string;
        mixElement?: string;
    };
    animation: {
        enable?: boolean;
        effects?: string;
        effectsIn?: string;
        effectsOut?: string;
        duration?: number;
        easing?: string;
        applyPerspective?: boolean;
        perspectiveDistance?: string;
        perspectiveOrigin?: string;
        queue?: boolean;
        queueLimit?: number;
        animateResizeContainer?: boolean;
        animateResizeTargets?: boolean;
        staggerSequence?: Function;
        reverseOut?: boolean;
        nudge?: boolean;
        clampHeight?: boolean;
        clampWidth?: boolean;
    };
}

declare var mixitup;

export class FilterMixitup {
    private _wrapperElement: HTMLElement;
    private _element: any;
    private _options: FilterMixitupOptions = {
        classNames: {
            block:'filter__mixitup',
            elementContainer:'filter__container',
            elementFilter:'filter__element',
            elementSort:'filter__element',
            elementMultimix:'filter__element',
            elementToggle:'filter__element',
            modifierActive: 'active',
            modifierDisabled: 'disabled',
            modifierFailed: 'failed',
            delineatorElement: '__',
            delineatorModifier: '--'
        },
        load:{
            filter:'all',
            sort:'default:asc'
        },
        selectors: {
            mixElement: '.mix',
            filter: '.filter__mixitup__filter__element',
        },
        animation: {
            enable: true,
            effects: 'fade scale',
            effectsIn: '',
            effectsOut: '',
            duration: 600,
            easing: 'ease',
            applyPerspective: true,
            perspectiveDistance: '3000px',
            perspectiveOrigin: '50% 50%',
            queue: true,
            queueLimit: 3,
            animateResizeContainer: true,
            animateResizeTargets: false,
            staggerSequence: null,
            reverseOut: false,
            nudge: true,
            clampHeight: true,
            clampWidth: true
        }
	};

    constructor(private wrapper: HTMLElement, options?: FilterMixitupOptions) {
        this._wrapperElement = wrapper;
        this._options = { ...this._options, ...options };
		this.init();
    }

    private init() {
        this._element = mixitup(this._wrapperElement, {
            classNames: {
                block:this._options.classNames.block,
                elementContainer:this._options.classNames.elementContainer,
                elementFilter:this._options.classNames.elementFilter,
                elementSort:this._options.classNames.elementSort,
                elementMultimix:this._options.classNames.elementMultimix,
                elementToggle:this._options.classNames.elementToggle,
                modifierActive: this._options.classNames.modifierActive,
                modifierDisabled: this._options.classNames.modifierDisabled,
                modifierFailed: this._options.classNames.modifierFailed,
                delineatorElement: this._options.classNames.delineatorElement,
                delineatorModifier: this._options.classNames.delineatorModifier
            },
			selectors: {
				target: this._options.selectors.mixElement,
				control: this._options.selectors.filter
			},
			load: {
                filter: this._options.load.filter,
                sort: this._options.load.sort
			},
			animation: {
				enable: this._options.animation.enable,
                effects: this._options.animation.effects,
                effectsIn: this._options.animation.effectsIn,
                effectsOut: this._options.animation.effectsOut,
				duration: this._options.animation.duration,
                easing: this._options.animation.easing,
                applyPerspective: this._options.animation.applyPerspective,
				perspectiveDistance: this._options.animation.perspectiveDistance,
				perspectiveOrigin:this._options.animation.perspectiveOrigin,
				queue:this._options.animation.queue,
				queueLimit:this._options.animation.queueLimit,
				animateResizeContainer: this._options.animation.animateResizeContainer,
				animateResizeTargets:this._options.animation.animateResizeTargets,
				staggerSequence:this._options.animation.staggerSequence,
                reverseOut:this._options.animation.reverseOut,
                nudge: this._options.animation.nudge,
                clampHeight: this._options.animation.clampHeight,
                clampWidth: this._options.animation.clampWidth
			}
		});
    }
}

export default function filtermixitup(
    wrapper: HTMLElement,
    options?: FilterMixitupOptions
): FilterMixitup {
    return new FilterMixitup(wrapper, options);
}
